import React from 'react';
import PropTypes from 'prop-types';
import { PROCESS_STATUS } from 'app/shared/hooks/useProcessItems';
import ExportProgress from './ExportProgress';
import ExportComplete from './ExportComplete';
import ExportError from './ExportError';

export default function BulkExportModalBody({ status, currentIndex, totalCount, error }) {
  switch (status) {
    case PROCESS_STATUS.PROCESSING:
      return <ExportProgress current={currentIndex} total={totalCount} />;
    case PROCESS_STATUS.COMPLETE:
      return <ExportComplete count={totalCount} />;
    case PROCESS_STATUS.ERROR:
      return <ExportError message={error} />;
    default:
      return null;
  }
}

BulkExportModalBody.propTypes = {
  status: PropTypes.string.isRequired,
  currentIndex: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  error: PropTypes.string,
};
